import { SearchTerm } from './SearchTerm';

const BiometricSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "baName",
        translationKey: "name"
    },
    {
        heading: "Address",
        accessor: "baAddress",
        searchOnName: "baAddress",
        translationKey: "address"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "baIp",
        translationKey: "ipAddress"
    },
    {
        heading: "Serial Number",
        accessor: "serialAddress",
        searchOnName: "baSerial",
        translationKey: "serialNumber"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "deviceImprox.site.siteName",
        translationKey: "site"
    },
    {
        heading: "Device",
        accessor: "device",
        searchOnName: "deviceImprox.devName",
        translationKey: "device"
    },
    {
        heading: "Preset",
        accessor: "preset",
        searchOnName: "bioProfile.trnName",
        translationKey: "preset"
    }
];

export default BiometricSearch;